import api from '@motionelements/core/src/api/base-api-v2';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string';

export const generatePredictions = async (payload, axiosConfig) => {
  const post = await api.request('post', '/v2/predictions', {
    ...(axiosConfig || {}), // for recaptcha headers
    data: payload,
  });
  return post;
};

export const getPredictions = async (params, axiosConfig) => {
  params = params || {};
  const config = {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
    ...(axiosConfig || {}),
  };

  return api.request('get', '/v2/predictions', config);
};

export const createStripeCheckoutUrl = async (payload, axiosConfig) => {
  const post = await api.request('post', '/v2/checkout', {
    ...(axiosConfig || {}), // for recaptcha headers
    data: payload,
  });
  return post;
};

export const createStripeBillingPortalUrl = async (payload, axiosConfig) => {
  const post = await api.request('post', '/v2/billing-portal', {
    ...(axiosConfig || {}), // for recaptcha headers
    data: payload,
  });
  return post;
};

export const checkoutSuccess = async (payload, axiosConfig) => {
  const post = await api.request('post', '/v2/checkout/success', {
    ...(axiosConfig || {}), // for recaptcha headers
    data: payload,
  });
  return post;
};

export const getPrediction = async (id) => {
  const request = await api.get(`/v2/predictions/${id}`);
  return request;
};

export const cancelPrediction = async (id) => {
  const request = await api.request('delete', `/v2/predictions/${id}`);
  return request;
};
